"use client"

import { GraduationCap } from "lucide-react"

export default function FoundersNoteSection() {
    return (
        <div className="bg-[#0097b2] py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
            <div className="max-w-screen-xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-4 sm:mb-6">
                    <div className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full mb-4 sm:mb-6">
                        <GraduationCap className="h-4 w-4 sm:h-5 sm:w-5 text-white" />
                        <span className="text-white font-semibold text-sm sm:text-base">From Our Founder</span>
                    </div>
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
                        Founder’s Note
                    </h1>
                    <p className="text-base sm:text-lg md:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
                        A message from Saumya Rai, the heart and vision behind SSS Achievers.
                    </p>
                </div>
                {/* Content Section */}
                <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-4 lg:p-6 mx-2 sm:mx-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
                        {/* Founder’s Image and Details */}
                        <div className="flex flex-col items-center lg:items-start">
                            <div className="relative w-full h-[16rem] sm:h-[20rem] md:h-[34rem] rounded-lg overflow-hidden mb-4 sm:mb-6">
                                <img
                                    src="../images/founder.webp"
                                    alt="Saumya Rai, Founder"
                                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                                />
                            </div>
                            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1">
                                Saumya Rai
                            </h3>
                            <p className="text-sm sm:text-base text-[#0097b2] font-medium mb-1">
                                Founder, SSS Achievers
                            </p>
                            <p className="text-xs sm:text-sm text-gray-600">
                                BA LLB, Education Leadership
                            </p>
                        </div>

                        {/* Founder’s Note */}
                        <div>
                            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                                Hello and welcome to SSS Achievers.
                            </p>
                            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                                I started this coaching institute with one main goal—to help students get the right guidance and support they need to succeed in their studies and career. Being a student myself once, I understand how important it is to have good teachers and the right direction.
                            </p>
                            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                                At SSS Achievers, we work hard to make learning easy and interesting for every student. Whether you are in school or college, our aim is to help you build a strong foundation and grow with confidence.
                            </p>
                            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                                This is not just a coaching center—it’s a place where we believe in your dreams and help you achieve them.
                            </p>
                            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                                Thank you for being a part of this journey.
                            </p>
                            <p className="text-sm sm:text-base md:text-lg text-gray-700 font-semibold leading-relaxed">
                                With best wishes,<br />
                                Saumya Rai<br />
                                Founder, SSS Achievers
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}